import React, { useState } from "react";
import ProductList from "./partials/ProductList";
import AddProduct from "./partials/AddProduct";
import BulkUploadModal from "./partials/BulkUploadModal";

export default function Product() {
  const [listKey, setListKey] = useState(0);

  return (
    <div>
      <div className="mx-3 mt-4">
        <div className="container-fluid d-flex justify-content-between align-items-center">
          <div className="pageTitle">
            <h1>Products</h1>
          </div>
          <div className="d-flex align-items-center gap-3">
            <BulkUploadModal onUploadComplete={() => setListKey(k => k + 1)} />
            <AddProduct type="add" />
          </div>
        </div>
        <ProductList key={listKey} />
      </div>
    </div>
  );
}
